// extracted by mini-css-extract-plugin
export var footer = "_p4-0";
export var inherit = "_p4-1";
export var input = "_p4-2";
export var modalContent = "_p4-3";
export var quillEditor = "_p4-4";
export var subtitle = "_p4-5";